import React from 'react';
import AdvertisingBusinessCard from 'components/AdvertisingBusinessCard';
import { SponsoredAdvert } from 'models/SponsoredAdvert';
import classNames from 'classnames';

import './AdvertRow.styles.scss';
import './AdvertRow.styles.responsive.scss';

type AdvertRowProps = {
  className?: string;
  ad: SponsoredAdvert;
  onSelect: () => void;
};

const AdvertRow: React.FC<AdvertRowProps> = (props) => {
  const { className, ad, onSelect } = props;

  const classes = classNames('res-advert-row', className);

  return (
    <div className={classes}>
      <AdvertisingBusinessCard
        title={ad.title}
        description={ad.description}
        coverPhoto={ad.coverPhoto}
        logoImage={ad.logoImage}
        onClick={() => onSelect()}
        ctaText={ad.ctaText}
        onlyMobileView
      />
    </div>
  );
};

export default AdvertRow;
